import { useEffect, useState, type MouseEvent } from 'react';
import { Checkbox } from 'semantic-ui-react';

import '~/features/admin/companies/styles.scss';
import { useQueryClient } from 'react-query';
import { Table } from '~/components';
import { useUpdateUserCompanySettings } from '~/mutations/team/useUpdateUserCompanySettings';
import { getListTeamMembersKey } from '~/requests/team';

const DefaultProjectLeadCheckbox = ({
  member,
  onUpdated,
}: {
  member: {
    id: string;
    name: string;
    email?: string;
    isDefaultProjectLead: boolean;
    isTeamInvite?: boolean;
    isUser?: boolean;
    active?: boolean;
  };
  onUpdated?: () => void;
}) => {
  const [checkedState, setCheckedState] = useState(member.isDefaultProjectLead);
  const queryClient = useQueryClient();

  const { mutateAsync, status } = useUpdateUserCompanySettings();

  useEffect(() => {
    setCheckedState(member.isDefaultProjectLead);
  }, [member.isDefaultProjectLead]);

  const applyLead = async (next: boolean) => {
    const payload = member.isTeamInvite
      ? { inviteId: member.id, isDefaultProjectLead: next }
      : { userId: member.id, isDefaultProjectLead: next };
    try {
      setCheckedState(next);
      await mutateAsync(payload);
      queryClient.invalidateQueries(getListTeamMembersKey());
      onUpdated?.();
    } catch (e: any) {
      console.error(e);
      setCheckedState(!next);
    }
  };

  return (
    <Table.Cell
      textAlign="center"
      className="admin-companies-active-cell"
      onClick={(e: MouseEvent) => e.stopPropagation()}
    >
      <Checkbox
        toggle
        checked={checkedState}
        disabled={status === 'loading' || member.active === false}
        aria-label={`Default lead for ${member.name ?? member.email ?? 'user'}`}
        onChange={(_, data) => {
          if (typeof data.checked === 'boolean') {
            void applyLead(data.checked);
          }
        }}
      />
    </Table.Cell>
  );
};

export default DefaultProjectLeadCheckbox;
